export default (rawItem) => {
  return {
    id: rawItem.id,
    name: rawItem.name,
    measureType: rawItem.measureType, //Unité
    precision: rawItem.precision, //Décimales
    factor: rawItem.factor, //Facteur
    shift: rawItem.shift, //Décalage (offset)
    colorCode: rawItem.colorCode, //Code Forme
    colorCodeHP: rawItem.colorCodeHP, //Code Forme HP
    lowerLimit: rawItem.lowerLimitm, //Seuil Bas
    upperDisplay: rawItem.upperDisplay, //Aff. Haut
    lowerDisplay: rawItem.lowerDisplay, //lowerDisplay
    upperAlarm: rawItem.upperAlarm, //Alarme Haut
    lowerAlarm: rawItem.lowerAlarm, //Alarme Bas
    sensor: rawItem.sensor,
  }

  //Missing: Seuil Haut
}
